import { defineTransform } from '@client/core/data/concerns/parses-from-json/transform-map';
import { Nullable } from '@client/core/data/types';

export class ProjectRentalAnalysis {
  constructor(
    public readonly afterRepairValue: Nullable<number>,
    public readonly purchasePrice: Nullable<number>,
    public readonly repairCosts: Nullable<number>,
    public readonly fixedCosts: Nullable<number>,
    public readonly financingCosts: Nullable<number>,
    public readonly shortTermEquity: Nullable<number>,
    public readonly incomePerMonth: Nullable<number>,
    public readonly operatingExpensesPerMonth: Nullable<number>,
    public readonly debtServicePerMonth: Nullable<number>,
    public readonly cashFlowAfterDebtPerMonth: Nullable<number>,
    public readonly totalLongTermReturnDollars: Nullable<number>,
    public readonly rentalPeriodHoldingYears: Nullable<number>,
    public readonly totalLongTermReturnPct: Nullable<number>,
    public readonly cashToStabilize: Nullable<number>,
    public readonly cashRemainingInDeal: Nullable<number>,
  ) {}
}

defineTransform(ProjectRentalAnalysis, (json, { fromSnakeCaseKeys }) => {
  return {
    ...fromSnakeCaseKeys(),
    // Backend sends 857.87% as 857.87. Frontend code expects percentages to be 8.5787.
    totalLongTermReturnPct: json.total_long_term_return_pct / 100,
  };
});
